/**
 * Jakiego łącza potrzeba, żeby ten materiał szedł bez zacinania.
 *
 * Liczymy z KONKRETNEGO pliku, a nie z widełek „zalecane 5 Mb/s": ten sam
 * odcinek w 720p z sieci i w 1080p z płyty różnią się kilkukrotnie, więc jedna
 * liczba dla wszystkiego byłaby albo strasząca, albo kłamliwa.
 *
 * To średnia z całości, nie szczyt. Materiał o zmiennej przepływności ma
 * fragmenty grubo powyżej średniej — scena z ruchem po ciemnym ujęciu potrafi
 * przekroczyć ją dwukrotnie. Dlatego doliczamy zapas: bez niego podana wartość
 * byłaby granicą, na której zacina się w najbardziej wymagających momentach,
 * czyli dokładnie tam, gdzie widzowi zależy najbardziej.
 */

/** Zapas nad średnią. 25% pokrywa typowe wahania przepływności w odcinku. */
const HEADROOM = 1.25;

/**
 * Megabity na sekundę, czyli jednostka z umowy z dostawcą łącza.
 *
 * Dziesiętne, nie 2^20: „100 Mb/s" w cenniku to 100 000 000 bitów. Liczenie
 * po mebibitach zaniżyłoby wynik o 5% i nie dałoby się go porównać z tym, co
 * widz ma zapisane w umowie.
 */
const BITS_PER_MEGABIT = 1_000_000;

export function requiredBitrateMbps(
  sizeBytes: number | null,
  durationSec: number | null,
): number | null {
  if (sizeBytes === null || durationSec === null) return null;
  if (!Number.isFinite(sizeBytes) || !Number.isFinite(durationSec)) return null;
  // Czas trwania krótszy niż sekunda daje absurdalne przepływności — przy
  // materiale tej długości pytanie o pasmo i tak jest bez znaczenia.
  if (sizeBytes <= 0 || durationSec < 1) return null;

  const raw = ((sizeBytes * 8) / durationSec / BITS_PER_MEGABIT) * HEADROOM;

  /**
   * Zaokrąglamy W GÓRĘ, bo to wymóg minimalny: „6 Mb/s" przy realnych 6,4
   * byłoby wartością, przy której się zacina. Poniżej dziesięciu megabitów
   * schodzimy do połówek, bo różnica 4 a 5 Mb/s jest tam istotna.
   */
  if (raw < 10) return Math.ceil(raw * 2) / 2;
  return Math.ceil(raw);
}

/** Zapis z przecinkiem, bo tak się po polsku pisze liczby dziesiętne. */
export function formatMbps(mbps: number): string {
  return Number.isInteger(mbps) ? String(mbps) : mbps.toFixed(1).replace('.', ',');
}
